import { useContext } from 'react'

import { NavigatorContext } from 'src/context/navigatorContext'

export default function useSidebar() {
    const context = useContext(NavigatorContext)

    if (!context) {
        throw new Error('Must be wrapped in NavigatorContext.Provider')
    }

    return context
}
